export const arrowRight = '\u2192';
export const emptyDiamond = '\u25C7';
